const body = document.body;
const fixedProductBar = document.querySelector('.FixedProductBar');
let scrollPos = 0;
let isFixedProductBarVisible = false;

if (fixedProductBar && typeof gsap !== 'undefined') {
	gsap.set(fixedProductBar, {
		top: -100,
		autoAlpha: 0
	});
}

function scrollTop(el, value) {
	if (value === undefined)
	{
		return el.scrollY;
	}
	else
	{
		if (el === window || el.nodeType === 9)
		{
			el.scrollTo(el.scrollX, value);
		}
		else
		{
			el.scrollY = value;
		}
	}
}


function checkScroll() {

	if (body.classList.contains('smooth-scroll'))
	{
		return false;
	}

	// window.scrollTop() is equivalent to (document.body.getBoundingClientRect()).top with inverse sign
	let scrollDistance = 800;
	let documentScrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
	let fixedProductBarDistance = 800;

	if (fixedProductBar && typeof gsap !== 'undefined')
	{
		if (documentScrollTop > fixedProductBarDistance && !isFixedProductBarVisible)
		{
			isFixedProductBarVisible = true;

			gsap.to(fixedProductBar, {
				top: 0,
				autoAlpha: 1,
				duration: 0.35,
				ease: 'power2.out'
			});
		}
		else if (documentScrollTop <= fixedProductBarDistance && isFixedProductBarVisible)
		{
			isFixedProductBarVisible = false;

			gsap.to(fixedProductBar, {
				top: -100,
				autoAlpha: 0,
				duration: 0.25,
				ease: 'power2.in'
			});
		}
	}

	if (scrollPos !== 0)
	{
		// detects new scroll state and compares it with the old one
		if (documentScrollTop < scrollPos)
		{
			if ((documentScrollTop - scrollPos) < -20)
			{
				body.classList.add('scrolled-up');
				body.classList.remove('scrolled-down');
			}
		}
		else
		{
			body.classList.add('scrolled-down');
			body.classList.remove('scrolled-up');
		}
	}

	// saves the new position for iteration
	scrollPos = documentScrollTop;

	if (scrollPos === 0)
	{
		body.classList.remove('scrolled-up', 'scrolled-down');
	}

	if (documentScrollTop > scrollDistance)
	{
		if (!body.classList.contains('sticky-header'))
		{
			body.classList.add('to-sticky-header');
		}

		body.classList.add('sticky-header');

		if (body.classList.contains('to-sticky-header'))
		{
			setTimeout(function () {
				body.classList.remove('to-sticky-header');
			}, 50);
		}
	}
	else
	{
		if (body.classList.contains('sticky-header'))
		{
			body.classList.add('to-normal-header');
		}

		if (body.classList.contains('to-normal-header'))
		{
			setTimeout(function () {
				body.classList.remove('to-normal-header');
				body.classList.remove('sticky-header');
			}, 50);
		}
	}
}

checkScroll();


window.addEventListener('scroll', function () {

	checkScroll();

});